import {useEffect, useState} from 'react';

export const usePagination = (initialPage: number, totalItems: number, itemsPerPage: number) => {
    const [totalPages, setTotalPages] = useState<number>(Math.ceil(totalItems / itemsPerPage));
    const [currentPage, setCurrentPage] = useState(initialPage);

    useEffect(() => {
        setTotalPages(Math.ceil(totalItems / itemsPerPage));
    }, [totalItems, itemsPerPage]);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    const handlePageChange = (page: number) => {
        if (page <= totalPages) setCurrentPage(page);
    };

    return {currentPage, handlePageChange, totalPages, startIndex, endIndex};
};
